import React, { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFetchUsers from '../../hooks/users/useFetchUsers';
import { setSelectedUserAction } from '../../redux/actions/usersActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import BlockUserModal from './modals/BlockUserModal';
import UpdateUserModal from './modals/UpdateUserModal';
import UsersTable from './UsersTable';

const UsersList = () => {
  const dispatch = useDispatch();
  const { loading, users, refresh } = useFetchUsers();
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [showBlockUserModal, setShowBlockUserModal] = useState(false);

  const handleUserClick = (user) => {
    dispatch(setSelectedUserAction(user));
    setShowUpdateUserModal(true);
  };

  const handleUpdateUserModalSubmit = async () => {
    refresh();
    setShowUpdateUserModal(false);
  };

  const handleUserBlockClick = (user) => {
    dispatch(setSelectedUserAction(user));
    setShowBlockUserModal(true);
  };

  const handleBlockUserModalSubmit = async () => {
    refresh();
    setShowBlockUserModal(false);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showUpdateUserModal && (
          <UpdateUserModal
            onModalSubmit={() => handleUpdateUserModalSubmit()}
            onModalClose={() => setShowUpdateUserModal(false)}
          />
        )}
        {showBlockUserModal && (
          <BlockUserModal
            onModalSubmit={() => handleBlockUserModalSubmit()}
            onModalClose={() => setShowBlockUserModal(false)}
          />
        )}
        <>
          <UsersTable
            onUserClick={handleUserClick}
            onUserBlockClick={handleUserBlockClick}
            users={users}
            loading={loading}
          />
          {users.length === 0 && !loading && <EmptyContent title={'Список користувачів порожній'} />}
        </>
      </div>
    </Suspense>
  );
};

export default memo(UsersList);
